import {Role} from "@leap4/auth";

export const baseBackendRoute = process.env.REACT_APP_BACKEND_BASE_URL + "";
export const BACKEND_SERVICE_NAME = "papa v2";
export const logoutUrl = baseBackendRoute + "/app/logout";
export const requiredAuthRoles: Role[] = [Role.ADMIN];
export const meMultiUrl = baseBackendRoute + "/app/me_multi";
export const setCookieUrl = baseBackendRoute + "/app/set-cookie";
export const loginUrl = (process.env.REACT_APP_AUTH_SERVER_BASE_URL || "https://api.auth.adte-system.com") + "/users/login";

// papa 2 app
export const sellersBaseUrl = baseBackendRoute + "/sellers";
export const baseSellerAdsTxtCheckUrl = baseBackendRoute + "/sellerAdsTxtCheck";
export const baseSiteUrl = baseBackendRoute + "/site";
export const userBaseUrl = baseBackendRoute + "/users";
export const demandBaseUrl = baseBackendRoute + "/demands";
export const demandWLGeneratorBaseUrl = baseBackendRoute + "/demandWL";
export const appsDataBaseUrl = baseBackendRoute + "/appsData";
export const integrationBaseUrl = baseBackendRoute + "/integrations";
export const runLogsBaseUrl = baseBackendRoute + "/runLogs";
export const xroadsMonitoringBaseUrl = baseBackendRoute + "/xroads-monitoring";
export const trackedPublishersBaseUrl = baseBackendRoute + "/trackedPublishers";
export const trackedLinesBaseUrl = baseBackendRoute + "/trackedLines";
